import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_354: DocMigration = {
  maxSchemaVersion: "0.0.354",
  apply(json: any) {
    if (json.props) {
      json.propInstances = {};

      for (const [propId, prop] of Object.entries(json.props)) {
        if (!prop) {
          continue;
        }
        prop["entityType"] = "PROP_INSTANCE";
        json.propInstances[propId] = prop;
      }

      delete json.props;
    }

    if (json.locked) {
      for (const [hash, handle] of Object.entries(json.locked)) {
        if (hash.startsWith("prop.")) {
          json.locked["propInstance." + hash.split(".")[1]] = { ...(handle as {}), type: "PROP_INSTANCE" };
          delete json.locked[hash];
        }
      }
    }

    if (json.hidden) {
      for (const [hash, handle] of Object.entries(json.hidden)) {
        if (hash.startsWith("prop.")) {
          json.hidden["propInstance." + hash.split(".")[1]] = { ...(handle as {}), type: "PROP_INSTANCE" };
          delete json.hidden[hash];
        }
      }
    }

    if (json.entityGroups) {
      for (const [hash, groupId] of Object.entries(json.entityGroups)) {
        if (hash.startsWith("prop.")) {
          json.entityGroups["propInstance." + hash.split(".")[1]] = groupId;
          delete json.entityGroups[hash];
        }
      }
    }

    if (json.entityRoomLayouts) {
      for (const [hash, groupId] of Object.entries(json.entityRoomLayouts)) {
        if (hash.startsWith("prop.")) {
          json.entityRoomLayouts["propInstance." + hash.split(".")[1]] = groupId;
          delete json.entityRoomLayouts[hash];
        }
      }
    }

    if (json.auxOptionSets) {
      for (const optionSet of Object.values(json.auxOptionSets)) {
        const hotspotEntities = optionSet?.["ineligibleHotspotEntities"];
        if (hotspotEntities) {
          for (const [hash, flag] of Object.entries(hotspotEntities)) {
            if (hash.startsWith("prop.")) {
              hotspotEntities["propInstance." + hash.split(".")[1]] = flag;
              delete hotspotEntities[hash];
            }
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_354;
